import { Component } from '@angular/core';

@Component({
  selector: 'sd-oidc-callback',
  template: ''
})
export class OidcCallbackComponent {}
